module.exports = __webpack_public_path__ + "static/media/YF100_2.ce860a0a.jpg";